module.exports = __webpack_public_path__ + "img/signup-guide-02-02.19158238.png";